export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getHeatMapStatistic: async function (_, payload) {
      let {data} = await this.$api.heatMap.index(payload);
      return data;
    }
  }
};
